module.exports = __webpack_public_path__ + "img/story-bg.e75f239d.jpg";